import React, { useContext } from "react";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Moment from "react-moment";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import ReplayIcon from "@mui/icons-material/Replay";
import { CheckCircle, QrCodeScanner, Scanner, ScannerSharp } from "@mui/icons-material";

function TicketsList(props) {
  const { editTicket, handleChangePage, handleChangeRowsPerPage, handleDetail, tickets, page, rowsPerPage, meta, refundAction, markAsUsed, tabValue } =
    props;
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <>
      <TableContainer className={"box-shadow"} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
                Sl.No
              </TableCell>
              <TableCell style={{ color: "#B3B3B3" }}>
                <span style={{ color: "#616B88" }}>Name</span> / Museum
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Ticket Number
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Visitor Type
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Exhibition Type
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Total Visitor
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Validity
              </TableCell>
              <TableCell align="center" sx={{ color: "#B3B3B3" }}>
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tickets?.length > 0 ? (
              tickets?.map((ticket, index) => (
                <TableRow hover key={ticket.id}>
                  <TableCell>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                  <TableCell
                    className={"hand-cursor"}
                    onClick={() => handleDetail(ticket.id)}
                    sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
                  >
                    <Box display="flex" flexDirection="column" sx={{ ml: 1 }}>
                      <Typography
                        className={"text-capitalize"}
                        sx={{
                          fontSize: 14,
                          fontWeight: 600,
                        }}
                      >
                        {ticket?.user_name || "-"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "#6F7098",
                        }}
                      >
                        {ticket?.museum_name}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell className={"hand-cursor"} onClick={() => handleDetail(ticket.id)}>
                    {ticket?.ticket_no}
                  </TableCell>
                  <TableCell className={"hand-cursor text-capitalize"} onClick={() => handleDetail(ticket.id)}>
                    {ticket?.visitor_type_detail?.name || "-"}
                  </TableCell>
                  <TableCell className={"hand-cursor"} onClick={() => handleDetail(ticket.id)}>
                    {ticket?.exhibitions?.[0]?.name || "-"}
                  </TableCell>
                  <TableCell className={"hand-cursor"} onClick={() => handleDetail(ticket.id)}>
                    {ticket?.no_of_visitor}
                  </TableCell>
                  <TableCell className={"hand-cursor"} onClick={() => handleDetail(ticket.id)}>
                    <Moment format={"ll"}>{ticket?.validity}</Moment>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                      {tabValue === 0 &&
                        <IconButton
                          onClick={() => markAsUsed(ticket?.id)}
                          sx={{
                            bgcolor: "#fff",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                            color: "#4cd502"
                          }}
                          title="Mark as used">
                          <QrCodeScanner />
                        </IconButton>
                      }
                      {user?.current_role?.name === "receptionist" && (
                        <IconButton
                          onClick={() => refundAction(ticket?.id)}
                          sx={{
                            bgcolor: "#fff",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                            color: "#ff6b6b"
                          }}
                          title="Request Refund"
                        >
                          <ReplayIcon />
                        </IconButton>
                      )}
                      {tickets?.length > 0 && (user?.current_role?.name === "curator" || user?.current_role?.name === "museum_chief" || user?.current_role?.name === "super_admin") && (
                        <IconButton
                          onClick={() => editTicket(ticket?.id)}
                          sx={{
                            bgcolor: "#fff",
                            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                          }}
                        >
                          <DriveFileRenameOutlineIcon />
                        </IconButton>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8} style={{ textAlign: "center" }}>
                  <Typography style={{ color: "red" }}>Not Available Tickets</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 20, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default TicketsList;
